import { render, staticRenderFns } from "./TestingOrganization.vue?vue&type=template&id=ef9a7524&scoped=true&"
import script from "./TestingOrganization.vue?vue&type=script&lang=ts&"
export * from "./TestingOrganization.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef9a7524",
  null
  
)

export default component.exports